import { render, staticRenderFns } from "./ProvinceCityAreaControl.vue?vue&type=template&id=3cbae6ca&scoped=true&"
import script from "./ProvinceCityAreaControl.vue?vue&type=script&lang=ts&"
export * from "./ProvinceCityAreaControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbae6ca",
  null
  
)

export default component.exports